import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import CompanyDetailContMain from "presentation/view/container/Company/CompanyDetailContMain";

CommonEntrypoint(<CompanyDetailContMain/>)